import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const RecurringProductionStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "recurring-production",
})`
  .recurring-production-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .recurring-production-description {
    color: red;
    font-size: 0.875rem;
    margin: 0;
  }

  .recurring-production-times-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;
  }

  .time-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    gap: 16px;
  }

  .time-list-item__editors {
    flex: 1;
    display: flex;
    gap: 12px;
  }

  .time-list-item__buttons {
    display: flex;
    gap: 8px;
  }

  .time-list-item__data {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .time-list-item__data--row {
    display: flex;
    align-items: center;
    gap: 12px;

    label {
      font-weight: 500;
      min-width: 100px;
    }
  }

  .time-list-cell {
    padding: 4px 8px;
    background-color: white;
    border-radius: 4px;
  }

  .add_button {
    margin-top: 8px;
  }
`;
